export default {
  content: `<p>
    중국의 컴퓨팅 파워 발전은 '지능형 컴퓨팅을 주축으로, 전국 일체형 컴퓨팅 네트워크를 핵심으로' 하는 수조 규모의 산업 구조를 형성했습니다. '동수서산(東数西算, 동부 데이터를 서부 컴퓨팅 리소스로 처리)' 전략을 기반으로, 중국은 컴퓨팅과 전력의 심층적 협력을 통해 컴퓨팅을 '수도·전기'처럼 즉시 사용 가능한 공공 인프라로 전환하고 있습니다.
</p>
<p>
    중국의 컴퓨팅 발전은 '하드웨어 점유 경쟁'에서 '전국 일체형 운영 및 서비스'로의 심층적 전환의 중요한 변곡점에 있습니다. 미국의 하이테크 대기업(CapEx)에 의한 순수 시장 주도 모델과 달리, 중국의 컴퓨팅은 '정부의 톱다운 설계 + 시장의 혁신 활력'이라는 독특한 양축 동력 특성을 보여줍니다.
</p>`,
  t1: `<p>
    <strong>지능형 컴퓨팅 규모의 폭발적 성장:</strong> 2026년 3월 말 기준, 중국의 구축된 지능형 컴퓨팅 규모는 188.2만 P(1882 EFLOPS 환산)에 달하며, 전년 대비 2.5배의 도약적 성장을 기록했고, 지능형 컴퓨팅이 절대적인 증가량의 주체가 되었습니다.
</p>
<p>
    <strong>'8+10+3' 공간 구축 완성:</strong> 8대 국가 컴퓨팅 허브, 10대 국가 데이터센터 클러스터, 3대 컴퓨팅-전력 협력 발전 지역을 중점으로 하는 공간 구조가 완전히 확립되어, 전국 컴퓨팅 리소스의 집약적·규모적 발전을 실현했습니다.
</p>
<p>
    <strong>'20밀리초 지연 권역' 구축:</strong> 허브 간 145개의 간선 광케이블이 건설되어, 전국 각 성에서 8대 허브까지의 네트워크 전송 지연이 모두 20밀리초 이내로 낮아졌으며, '천 리 밖에서도 순간 도달'하는 컴퓨팅-네트워크 융합이 현실이 되었습니다.
</p>
<p>
    <strong>애플리케이션이 '훈련'에서 '추론'으로 전환되고 하위로 확산 가속화:</strong> 대규모 모델의 전면적인 상용화에 따라, 지능형 컴퓨팅 센터는 대규모 모델 '훈련' 주도에서 '추론' 주도로 전환되고 있으며, 컴퓨팅은 제조업, 교통, 행정 등 다양한 산업 분야에 깊이 접목되고 있습니다.
</p>
<p>
    <strong>핵심 현실적 과제:</strong> 컴퓨팅 공급에 구조적 미스매치가 존재하며, 일부 서부 노드는 인프라 취약으로 인해 '구축했으나 사용하지 않음, 낮은 활용률'이라는 우려에 직면해 있는 반면, 동부의 고급·고신뢰성 컴퓨팅은 여전히 부족합니다. 동시에, 고급 AI 칩의 자체 혁신도 돌파구가 필요한 상황입니다.
</p>
<p>
    <br/>
</p>`,
  t2: `<p>
    <strong>세계 최대의 하위 애플리케이션 및 토큰 소비 시장:</strong> 중국은 세계에서 가장 밀집된 산업 시나리오, 가장 큰 AI 애플리케이션 상용화 시장, 그리고 가장 빠른 토큰 소비 성장률을 보유하고 있습니다. 전국 일일 AI 토큰 호출량은 140조 개로 급증했으며, 2년 전보다 수천 배 성장하여 막대한 시장 흡수력을 제공하고 있습니다.
</p>
<p>
    <strong>국가 체제 하의 '동수서산' 및 리소스 스케줄링 역량:</strong> 중국은 세계적으로 유례없는 '하나의 큰 그림' 스케줄링 우위를 가지고 있습니다. '동수서산' 8대 허브와 10대 클러스터의 구축을 통해, 동부의 고밀도 컴퓨팅 수요를 서부의 풍력·태양광 친환경 전력이 풍부한 지역으로 유도하여, 미국이 겪고 있는 '전력망 마비'라는 지역적 위기를 효과적으로 회피했습니다.
</p>
<p>
    <strong>비용 절감 및 효율성 향상을 위한 초고속 인프라 구축 역량:</strong> 중국의 완비된 전자제조 산업체인을 기반으로, 국내 클라우드 업체들은 이미 전 모듈형 데이터센터 아키텍처(예: 알리바바 클라우드 CUBE 5.0)를 구현하여, 대규모 AIDC의 납품 기간을 업계 전통적인 1년에서 100일로 대폭 단축하고, 구축 비용도 10% 절감했습니다.
</p>
<p>
    <br/>
</p>`,
  t3: `<p>
    <strong>구조적 불균형, '한쪽은 부족하고 한쪽은 놀고 있는' 모순 상황:</strong>
</p>
<p>
    <strong>분자와 분모의 미스매치:</strong> 총 규모는 방대하지만, 국내 지능형 컴퓨팅 센터의 평균 유효 활용률은 30% 미만입니다.
</p>
<p>
    <strong>중저급은 과잉, 고급은 여전히 부족:</strong> 중저급 및 단편화된 컴퓨팅은 대량으로 유휴 상태인 반면, 수조 개 파라미터의 초대규모 모델 사전 학습을 안정적으로 감당할 수 있는 고품질·밀결합·초저지연의 고급 컴퓨팅은 여전히 심각하게 부족합니다.
</p>
<p>
    <strong>엔드투엔드 납품 및 지역 간 스케줄링의 기술적 병목:</strong><br/>현재 전국 컴퓨팅 네트워크는 '리소스 가시화(모니터링)'를 달성했지만, '작업 실행 가능성(납품)'은 아직 완전히 실현되지 않았습니다. 대규모 모델 훈련은 카드 간 고대역폭·밀결합 통신을 매우 엄격하게 요구하며, 서부에 흩어져 있는 유휴 카드를 물리적으로 직접 연결하여 동부의 핵심 훈련 작업을 처리하기는 어렵고, 지역 간 전송 비용도 높으며 데이터 프라이버시 규제 제약도 많습니다.
</p>
<p>
    <strong>국산 소프트웨어·하드웨어 생태계(CUDA 장벽)가 가장 어려운 과제:</strong><br/>화웨이 어센드, 하이광 등의 하드웨어 성능이 빠르게 발전하고 있지만, NVIDIA의 CUDA 생태계는 전 세계 개발자들에게 깊이 자리 잡고 있습니다. 국산 컴퓨팅은 하위 소프트웨어 스택, 연산자 라이브러리 적응, 대규모 모델 심층 최적화에서 거대한 생태계 전환 장벽에 직면하여, '하드웨어는 만들기 쉽지만, 생태계는 구축하기 어렵다'는 상황을 맞이하고 있습니다.
</p>
<p>
    <br/>
</p>`,
  t4: `<p>
    <strong>'하드웨어 납품'에서 '토큰 임대 및 서비스 운영'으로 전환</strong><br/>컴퓨팅은 수도·전기처럼 즉시 사용 가능한 공공 리소스로 변모하고 있습니다. 업체들은 단순히 서버를 판매하는 것을 넘어, 3대 통신사업자 및 컴퓨팅 하드웨어 대기업들은 '토큰 팩토리' 모델 및 국가 슈퍼컴퓨팅 인터넷 서비스로 전면 전환하고 있습니다.
</p>
<p>
    <strong>AI 이기종 컴퓨팅 풀링의 확산</strong><br/>서로 다른 브랜드, 서로 다른 아키텍처의 칩 간 하드웨어 격리를 해소하기 위해, 국내에서는 'AI 이기종 컴퓨팅 풀링 플랫폼' 도입이 가속화되고 있으며, 화웨이 어센드, 하이광 DCU, 무어 스레드, 한무기 등 여러 국산 칩을 동일한 클러스터 내에서 혼합 배치하고 무감각하게 호출하는 것을 실현하고 있습니다.
</p>
<p>
    <strong>산업체인의 '역성장'을 통한 공백 메우기</strong><br/>외부 지정학적 압력으로 인해, 중국 컴퓨팅 산업은 '초기 완제품 통합 — 후기 하위 칩, 상호연결 토폴로지, 연산자 라이브러리(DTK, FlagOS 등)를 역습적으로 확보'하는 역성장 자주화 경로를 걸어가며, 전 스택의 자주적 통제를 가속화하고 있습니다.
</p>
<p>
    <br/>
</p>`,
};
